<body [attr.data-theme]="themeDarkClass" class="{{themeltrClass}}">

  <div id="elearn-layout" class="theme-black">
    <!-- sidebar -->
    <app-leftbar id='leftbar'></app-leftbar>

    <!-- main body area -->
    <div class="main px-lg-4 px-md-4">
      <!-- Body: Header -->
      <app-header></app-header>

      <!-- Body: Body -->
      <router-outlet>
        <div fxFlex fxLayout="row wrap" fxLayoutAlign="space-around start">
          <div class="custom-card content-container" fxFlex="80">
            <div class="content-area__main">
              <div>
                <h4 class=" fw-bold flex-fill title-left" *ngIf="currentUserRole == 'ADMIN' || currentUserRole == 'SUPER ADMIN' || currentUserRole == 'STAFF'">Sales Report</h4>
                <h4 class=" fw-bold flex-fill title-left" *ngIf="currentUserRole == 'PARENTS' || currentUserRole == 'TEACHER'">Purchase History</h4>
                <div style="margin-top: 30px;">
                  <transaction-table [transactionsList]="transactionList" (transactionUpdatedEvent)="transactionUpdatedHandler($event)" (exportEvent)="exportHandler($event)" (exportInvoiceEvent)="exportInvoiceHandler($event)"></transaction-table>
                </div>
                <span class="total-amount">
                  <img width="25" height="25" [src]="'./assets/images/calorie.png'" /> Total Calories: {{totalCalorie}} kcal
                </span>
                <span class="total-amount" *ngIf="currentUserRole == 'PARENTS' || currentUserRole == 'TEACHER'">Total Spent: RM {{ setPriceDecimal(totalPaidAmount) }}</span>
                <span class="total-amount" *ngIf="currentUserRole == 'ADMIN' || currentUserRole == 'SUPER ADMIN' || currentUserRole == 'STAFF'">Gross Sale (A): RM {{ setPriceDecimal(totalPaidAmount) }}</span>
                <span class="total-amount" *ngIf="currentUserRole == 'ADMIN' || currentUserRole == 'SUPER ADMIN' || currentUserRole == 'STAFF'">Fee (B): RM {{ setPriceDecimal(totalFee) }}</span>
                <span class="total-amount" *ngIf="currentUserRole == 'ADMIN' || currentUserRole == 'SUPER ADMIN' || currentUserRole == 'STAFF'"><b>Net Sale (A - B): RM {{ setPriceDecimal(totalPaidAmount - totalFee ) }}</b></span>
                <mat-paginator 
                  (page)="handlePageEvent($event)" 
                  [length]="totalResult" 
                  [pageSize]="limit"
                  [showFirstLastButtons]="true" 
                  [pageSizeOptions]="getPageSizeOptions()" 
                  [pageIndex]="pageIndex"
                  aria-label="Select page"
                  #paginator>
                </mat-paginator>
                <ng-template #customLoadingTemplate>
                  <div class="custom-class">
                    <h3>Saving...</h3>
                  </div>
                </ng-template>
                <ngx-loading
                  [show]="loading"
                  [config]="{ backdropBorderRadius: '3px' }"
                  [template]="customLoadingTemplate"
                ></ngx-loading>
              </div>
            </div>
          </div>
        </div>
      </router-outlet>
    </div>
  </div>
</body>